var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    fill: "#7898FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#F7F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1863 26.652V26.1129H26.5686V26.4804C26.5686 27.3197 27.249 28 28.0882 28C28.9275 28 29.6078 27.3197 29.6078 26.4804V21.2192C29.6078 21.0644 29.5719 20.9118 29.5029 20.7733L28.1373 18.0323H29.129C29.6101 18.0323 30 17.6423 30 17.1613C30 16.6803 29.6101 16.2903 29.129 16.2903H27.9187C27.313 16.2903 26.74 16.0159 26.3604 15.544L24.6139 13.3732C24.4241 13.1372 24.1376 13 23.8348 13H16.1708C15.8648 13 15.5756 13.1401 15.386 13.3803L13.6888 15.5297C13.3095 16.0101 12.7312 16.2903 12.1191 16.2903H10.871C10.3899 16.2903 10 16.6803 10 17.1613C10 17.6423 10.3899 18.0323 10.871 18.0323H11.8137L10.5777 20.7887C10.52 20.9174 10.4902 21.0568 10.4902 21.1978V26.652C10.4902 27.3965 11.0937 28 11.8382 28C12.5827 28 13.1863 27.3965 13.1863 26.652ZM17.1652 14.25C16.5401 14.25 15.9509 14.5423 15.5727 15.04L15.0181 15.77C14.5178 16.4284 14.9874 17.375 15.8143 17.375H24.3436C25.1886 17.375 25.6527 16.3919 25.1157 15.7395L24.4897 14.979C24.1098 14.5174 23.5434 14.25 22.9456 14.25H17.1652ZM12.2544 21.8068C12.2544 21.3257 12.6443 20.9358 13.1254 20.9358H15.5011C15.9821 20.9358 16.372 21.3257 16.372 21.8068C16.372 22.2878 15.9821 22.6777 15.5011 22.6777H13.1254C12.6443 22.6777 12.2544 22.2878 12.2544 21.8068ZM24.5957 20.9358C24.1147 20.9358 23.7247 21.3257 23.7247 21.8068C23.7247 22.2878 24.1147 22.6777 24.5957 22.6777H26.9714C27.4524 22.6777 27.8424 22.2878 27.8424 21.8068C27.8424 21.3257 27.4524 20.9358 26.9714 20.9358H24.5957Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.8ed674a870f3dc359b1d46a2049c42e4.svg";
export { ForwardRef as ReactComponent };